import React from "react";

import Grid2 from "@mui/material/Grid2";
import { Typography } from "@mui/material";
import ModlineIcon from "../images/homepage/Icon.png";
import { Link } from "react-router-dom";

const IconImage = (props) => (
  <img src={`${ModlineIcon}`} alt="Modline Logo" {...props} />
);

class Header extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <Grid2
        container
        spacing={0}
        alignItems="center"
        xs={12}
        sx={{
          backgroundColor: "#262626",
          borderBottom: ".1px white",
          display: "flex",
          alignItems: "center",
          justifyContent: "flex-start",
          position: "relative",
          zIndex: 1299,
          paddingLeft: { xs: "20px", sm: "30px" },
          width: {
            xs: `${this.props.sizing.vw - this.props.sizing.xs.usedWidth}px`,
            sm: `${this.props.sizing.vw - this.props.sizing.sm.usedWidth}px`,
          },
          maxWidth: "100%",
        }}
      >
        <Grid2 xs sx={{ height: { xs: "30px", sm: "83px" } }} />
        <Grid2
          xs={1}
          component={Link}
          to="/"
          sx={{
            display: { xs: "none", sm: "block" },
            height: "53px",
            width: "53px",
            alignSelf: "center",
          }}
        >
          <IconImage
            width="100%"
            height="100%"
            style={{ objectFit: "contain" }}
          />
        </Grid2>
        <Grid2
          xs={10}
          component={Typography}
          variant="h5"
          sx={{
            color: "#9aa2ae",
            fontSize: { xs: "13px", sm: "21px" },
            letterSpacing: { xs: ".5px", sm: "6px" },
            textAlign: "center",
            position: "absolute",
            left: "50%",
            transform: "translateX(-50%) scaleY(0.5)",
          }}
        >
          DESIGN &nbsp;|&nbsp; CREATE &nbsp;|&nbsp; INSPIRE
        </Grid2>
        <Grid2 xs={0} sm={1} />
        <Grid2
          xs={1}
          component={Link}
          to="/"
          sx={{
            display: { xs: "block", sm: "none" },
            textAlign: "right",
            height: "21px",
            width: "21px",
          }}
        >
          <IconImage
            width="100%"
            height="100%"
            style={{ objectFit: "contain" }}
          />
        </Grid2>
      </Grid2>
    );
  }
}

export default Header;
